import ImageWrapper from "../../ImageWrapper/ImageWrapper";
import './ProductTag.css';

function ProductTag({group, icon, label, labelColor, backgroundColor, borderColor, minWidth, margin}) {
    const tagStyle = () => {
        return {
            background: backgroundColor || '#005B80',
            borderColor: borderColor || backgroundColor || '#005B80',
            minWidth: minWidth || 'unset',
            margin: margin !== undefined ? margin : 5
        };
    };

    const labelStyle = () => {
        return {
            color: labelColor || '#FFFFFF'
        };
    };

    return (
        <div className={`product-tag${group ? ` ${group}` : ''}`} style={tagStyle()}>
            {icon && (
                <div className='product-tag-icon'>
                    <ImageWrapper image={icon} alt={label} display='block' width={20} height='auto' loadDelay={0.2}/>
                </div>
            )}
            <div className='product-tag-label' style={labelStyle()}>{label}</div>
        </div>
    );
}

export default ProductTag;